'use client'
import { useCallback, useRef } from 'react'
import { SwiperSlide, SwiperRef } from 'swiper/react'
import clsx from 'clsx'
import useIsMobile from '@/hooks/useIsMobile'

import Grid from '@/components/atoms/Grid'
import GridColumn from '@/components/atoms/GridColumn'
import Slider from '@/components/atoms/Slider'
import CustomNavigation from '@/components/atoms/Slider/CustomNavigation'

import BoxItem from '@/components/molecules/BoxList/BoxItem'
import { BoxItemProps } from '@/components/molecules/BoxList/BoxItem/BoxItem.types'

import customPaginationStyles from '@/components/atoms/Slider/CustomPagination.module.scss'

const BoxList = ({ boxes }: { boxes: BoxItemProps[] }) => {
  const isMobile = useIsMobile()
  const sliderRef = useRef<SwiperRef>(null)

  const handlePrev = useCallback(() => {
    if (!sliderRef.current?.swiper) return
    sliderRef.current.swiper.slidePrev()
  }, [])

  const handleNext = useCallback(() => {
    if (!sliderRef.current?.swiper) return
    sliderRef.current.swiper.slideNext()
  }, [])

  const pagination = {
    clickable: true,
    renderBullet: function (_: number, className: string) {
      return '<span class="' + clsx(className) + '"></span>'
    },
  }

  return isMobile ? (
    <div className={customPaginationStyles.pagination}>
      <Slider
        ref={sliderRef}
        totalSlides={boxes.length}
        spaceBetween={16}
        slidesPerView={1}
        pagination={pagination}
        config={{
          withPagination: true,
        }}
      >
        {boxes.map((box) => (
          <SwiperSlide
            style={{ height: 'auto' }}
            key={box.uuid}
          >
            <BoxItem {...box} />
          </SwiperSlide>
        ))}
        <CustomNavigation
          handlePrev={handlePrev}
          handleNext={handleNext}
        />
      </Slider>
    </div>
  ) : (
    <Grid
      noPadding
      gap='16px'
    >
      {boxes.map((box) => (
        <GridColumn
          key={box.uuid}
          span={box.highlighted ? 6 : 3}
        >
          <BoxItem {...box} />
        </GridColumn>
      ))}
    </Grid>
  )
}

export default BoxList
